export default __webpack_public_path__ + "static/media/arrowLeft.270b6793.svg";